import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';

import Maintenance from './MaintenanceBase';

export default withCombinedRouteParams(Maintenance);
